import React, { useState, useEffect } from "react";
import StudentAvatar from "../StudentAvatar/StudentAvatar";
import { setProgramName } from "../../../actions/tutorFeedActions";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import $ from "jquery";

const RightSection = (props) => {
  const {
    programsData,
    studentsData,
    attendanceData,
    isLoading,
    setProgramName,
  } = props;
  const [programSlot, setprogramSlot] = useState("");
  const [selectedProgram, setselectedProgram] = useState("");
  const [iconChange, seticonChange] = useState(false);
  useEffect(() => {
    $(".collapse")
      .on("shown.bs.collapse", function () {})

      .on("hidden.bs.collapse", function () {
        seticonChange("");
      });
  });

  const programNameFunction = (programName, program, courseId, slotId) => {
    var programidSlotId = `${program}||${slotId}`;
    setselectedProgram(programName);
    setprogramSlot(programidSlotId);
    setProgramName({ programName, program, courseId, slotId, programidSlotId });
  };
  return (
    <div
      className="rounded"
      style={{
        backgroundColor: "#343a40",
        color: "#fff",
        minHeight: 600,
        paddingTop: 20,
        paddingLeft: 10,
      }}
    >
      <h5 style={{ color: "#fed700" }} className="font-italic">
        Classes I am teaching:
      </h5>
      {!isLoading ? (
        <div id="accordion">
          {programsData &&
            programsData.map((item, index) => (
              <React.Fragment key={index}>
                {item.prog_name != null ? (
                  <Link to="/Teacherdashboard/ClassStart3">
                    <div
                      onClick={() =>
                        programNameFunction(
                          item.prog_name,
                          item.prog_id,
                          item.course_id,
                          item.slot_id
                        )
                      }
                      className={
                        selectedProgram == item.prog_name
                          ? "mt-2 p-1 gradeSelected"
                          : "mt-2 p-1 gradeNameMouse"
                      }
                    >
                      <span
                        style={{ color: "#fff" }}
                        class="fa-solid fa-book-open-reader ml-1"
                      ></span>
                      <label
                        key={index}
                        style={{ color: "#fff", fontSize: 13 }}
                        className="ml-2"
                        data-toggle=""
                        data-target={`#one${item.prog_id}-${item.slot_id}`}
                      >
                        {item.prog_name}
                      </label>
                    </div>
                  </Link>
                ) : null}

                {/* <div
                id={`one${item.prog_id}-${item.slot_id}`}
                className="collapse row p-2"
                aria-labelledby="headingOne"
                data-parent="#accordion"
                style={{ backgroundColor: "#273B5D" }}
              >
                <StudentAvatar programSlot={programSlot} slotId={item.slot_id} avatarData={studentsData} programName={item.prog_name} programId={item.prog_id} allProgramData={programsData} apiAttendanceData={attendanceData} />
              </div> */}
              </React.Fragment>
            ))}
        </div>
      ) : (
        <div className="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect(null, { setProgramName })(RightSection);
